/* eslint-disable no-console */
// This optional code is used to register a service worker. register() is not called by default.
// This lets app load faster on subsequent visits in prod, & gives it offline capabilities.
// However, it also means deployed updates will only be seen on subsequent visits to a page,
// after all existing tabs open on the page have been closed, since previously cached resources are updated in the background.
// Benefits of this model & instructions on how to opt-in: https://cra.link/PWA

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  // [::1] is the IPv6 localhost address.
  window.location.hostname === '[::1]' ||
  // 127.0.0.0/8 are considered localhost for IPv4.
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
)

const getSWFilename = (swUrl) => {
  const swParsedPath = swUrl.split('/')
  return swParsedPath[swParsedPath.length - 1]
}

export function register(swUrl, config) {
  if ('serviceWorker' in navigator) {
    // The URL constructor is available in all browsers that support SW.
    // const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href)
    // if (publicUrl.origin !== window.location.origin) {
    // Our service worker won't work if PUBLIC_URL is on a different origin from what our page is served on.
    // This might happen if a CDN is used to serve assets; see https://github.com/facebook/create-react-app/issues/2374
    // return
    // }

    // note: JOEY the ejs template needs to set/pass in a root path for the app
    // window.addEventListener('load', () => {
    /* eslint-disable-next-line no-undef */

    if (isLocalhost) {
      // This is running on localhost. Let's check if a service worker still exists or not.
      checkValidServiceWorker(swUrl, config)
      // Add some additional logging to localhost, pointing developers to the service worker/PWA documentation.
      navigator.serviceWorker.ready.then(() =>
        console.debug('This web app is being served cache-first by a service worker.')
      )
    } else registerValidSW(swUrl, config) // Is not localhost. Just register service worker
    // })
  }
}

function registerValidSW(swUrl, config) {
  console.debug(`Service Worker ${getSWFilename(swUrl)} registering...`)
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      const installingWorker = registration.installing
      const waitingWorker = registration.waiting
      if (!installingWorker && !waitingWorker)
        console.debug(`${getSWFilename(swUrl)} already installed. No updates available.`)
      if (waitingWorker?.state === 'installed') console.debug('Updated service worker waiting. Updates available.')

      registration.onupdatefound = () => {
        if (installingWorker == null) return

        installingWorker.onstatechange = () => {
          if (installingWorker?.state === 'installed') {
            console.debug(`Service Worker ${getSWFilename(swUrl)} installed!`)
            if (navigator.serviceWorker.controller) {
              // precached content has been fetched, but previous serviceWorker will serve old content until all client tabs are closed
              console.debug('New content is available and will be used when all tabs for this page are closed.')
              if (config && config.onUpdate) config.onUpdate(registration) // execute callback
            } else {
              console.debug('Content is cached for offline use.') // Everything is precached, show a 'ready for offline use' message
              if (config && config.onSuccess) config.onSuccess(registration) // execute callback
            }
          }
        }
      }
    })
    .catch((error) => console.error('Error during service worker registration:', error))
}

function checkValidServiceWorker(swUrl, config) {
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      // Ensure service worker exists, and that we really are getting a JS file.
      const contentType = response.headers.get('content-type')
      if (response.status === 404 || (contentType != null && contentType.indexOf('javascript') === -1)) {
        // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then((registration) =>
          registration.unregister().then(() => window.location.reload())
        )
      } else registerValidSW(swUrl, config) // Service worker found. Proceed as normal.
    })
    .catch(() => console.warn('No internet connection found. App is running in offline mode.'))
}

export function unregister(swURLToUnregister) {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        if (registration?.active?.scriptURL?.endsWith(swURLToUnregister)) {
          registration.unregister()
          console.debug(`Service Worker ${getSWFilename(swURLToUnregister)} Unregistered!`)
        }
      })
      .catch((error) => console.error(error.message))
  }
}
